import { combineReducers } from 'redux';
import * as actionTypes from './actionTypes';
// import * as routeActions from '../../routes'

const defaultStage = '1';

export const stageReducer = (state = defaultStage, action) => {
  switch (action.type) {
    case actionTypes.SET_STAGE:
      return action.stage;

    // case routeActions.LOCATION_BOOK:
    // 	return action.stage || state

    default:
      return state;
  }
};

export default combineReducers({
  stage: stageReducer,
});

export const getCurrentStage = state => state.stage;
